import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { foldersKeys } from '../../folders'

export const useRestoreSiteBoxDocument = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['restoreDocument']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...siteBoxDocumentsKeys.restoreDocument,
    onSuccess: (_, { documentId }) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
